import React, { useEffect, useState } from "react";
import { Collapse } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Discover from "../../../components/re-usable/discover/discover";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { retrieveArticlesFiltereds397 } from "../../../redux/slice/news-articles/articles-filtered397-slice";
import { retrieveArticlesFiltereds398 } from "../../../redux/slice/news-articles/articles-filtered398-slice";
import { retrieveArticlesFiltereds399 } from "../../../redux/slice/news-articles/articles-filtered399-slice";
import { retrieveArticlesFiltereds400 } from "../../../redux/slice/news-articles/articles-filtered400-slice";
import { retrieveArticlesFiltereds404 } from "../../../redux/slice/news-articles/articles-filtered404-slice";
import { retrieveNewsArticlesSearchAuthor } from "../../../redux/slice/news-articles/news-articles-search-author-slice";
import { retrieveNewsArticlesSearchCategory } from "../../../redux/slice/news-articles/news-articles-search-category-slice";
import BooksCardArticle from "../article/books-card-article";
import CoursesCardArticle from "../article/courses-card-article";
import EventsCardArticle from "../article/events-card-article";
import NewsArticleBottom from "../article/news-article-bottom";
import NewsArticleTop from "../article/news-article-top";
import { default as NewsCardArticle } from "../article/news-card-article";
import DepartmentsSlider from "../departments-slider";
import NewsArticleSlider from "../news-article-slider";

import { Helmet } from "react-helmet-async";
import Slider from "react-slick";
import { retrieveLatestArticles } from "../../../redux/slice/latest-articles-slice";
import { retrieveLatestBooks } from "../../../redux/slice/latest-books-slice";
import { retrieveLatestCourses } from "../../../redux/slice/latest-courses-slice";
import { retrieveLatestEvents } from "../../../redux/slice/latest-events-slice";
import { retrieveArticlesFiltereds } from "../../../redux/slice/news-articles/articles-filtered-slice";
import { retrieveArticlesFiltereds393 } from "../../../redux/slice/news-articles/articles-filtered393-slice";
import { retrieveArticlesPinned } from "../../../redux/slice/news-articles/articles-pinned-slice";
import { retrieveFeatureFocus } from "../../../redux/slice/news-articles/regulatory-focus/feature-focus-slice";
import { retrieveForAuthors } from "../../../redux/slice/news-articles/regulatory-focus/for-authors-slice";
import { retrieveLatestFeatures } from "../../../redux/slice/news-articles/regulatory-focus/latest-features-slice";
import { retrieveRFQuarterly } from "../../../redux/slice/news-articles/regulatory-focus/rf-quarterly-slice";
import { RootState, useAppDispatch } from "../../../redux/store";
import NewsAndArticlesStyles from "./news-and-articles.styles";

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  initialSlide: 0,
  autoplay: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
      },
    },
  ],
};

const formatDate = (date: Date): string => {
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear().toString();
  return year + month + day;
};

const NewsAndArticlesComponent = () => {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const dispatch = useAppDispatch();
  const navigator = useNavigate();
  const [formOpen, setFormOpen] = useState(false);
  const [keyword, setKeyword] = useState<string>("");
  const [categoryID, setCategoryID] = useState<number>(0);
  const [authorCode, setAuthorCode] = useState<string>("");
  const [fromDate, setFromDate] = useState<string>("");
  const [toDate, setToDate] = useState<string>("");
  const [urlFromDate, setUrlFromDate] = useState<string>("");
  const [urlToDate, setUrlToDate] = useState<string>("");
  const { ArticlesFilteredsPinnedData } = useSelector((state: RootState) => state.ArticlesPinned);
  const { FeatureFocusData } = useSelector((state: RootState) => state.FeatureFocus);
  const { ForAuthorsData } = useSelector((state: RootState) => state.ForAuthors);
  const { LatestFeaturesData } = useSelector((state: RootState) => state.LatestFeatures);
  const { RFQuarterData } = useSelector((state: RootState) => state.RFQuarterly);
  const { ArticlesFilteredsData } = useSelector((state: RootState) => state.ArticlesFiltereds);
  const { ArticlesFiltereds393Data } = useSelector((state: RootState) => state.ArticlesFiltereds393);
  const { ArticlesFilteredsData397 } = useSelector((state: RootState) => state.ArticlesFiltereds397);
  //const { ArticlesFilteredsData398 } = useSelector((state: RootState) => state.ArticlesFiltereds398);
  const { ArticlesFiltereds399Data } = useSelector((state: RootState) => state.ArticlesFiltereds399);
  const { ArticlesFilteredsData400 } = useSelector((state: RootState) => state.ArticlesFiltereds400);
  const { ArticlesFilteredsData404 } = useSelector((state: RootState) => state.ArticlesFiltereds404);
  const { trendingNewsData } = useSelector((state: RootState) => state.latestArticles);
  const { featuredBooksData } = useSelector((state: RootState) => state.latestBooks);
  const { featuredLearningData } = useSelector((state: RootState) => state.latestCourses);
  const { popularEventsData } = useSelector((state: RootState) => state.latestEvents);
  const { NewsArticlesSearchCategoryData } = useSelector((state: RootState) => state.newsArticlesSearchCategory);
  const { NewsArticlesSearchAuthorData } = useSelector((state: RootState) => state.newsArticlesSearchAuthor);

  let QueryParamsType = { categoryId: "394;399;402;401;393;79", isInclude: false, noOfArticles: 12 };

  useEffect(() => {
    dispatch(retrieveArticlesPinned());
    dispatch(retrieveFeatureFocus());
    dispatch(retrieveForAuthors());
    dispatch(retrieveLatestFeatures());
    dispatch(retrieveRFQuarterly());
    dispatch(retrieveArticlesFiltereds(QueryParamsType));
    dispatch(retrieveArticlesFiltereds393({ isInclude: true, noOfArticles: 3 }));
    dispatch(retrieveArticlesFiltereds397({ isInclude: true, noOfArticles: 3 }));
    dispatch(retrieveArticlesFiltereds398({ isInclude: true, noOfArticles: 3 }));
    dispatch(retrieveArticlesFiltereds399({ isInclude: true, noOfArticles: 2 }));
    dispatch(retrieveArticlesFiltereds400({ isInclude: true, noOfArticles: 3 }));
    dispatch(retrieveArticlesFiltereds404({ isInclude: true, noOfArticles: 3 }));
    dispatch(retrieveLatestArticles(2));
    dispatch(retrieveLatestBooks(2));
    dispatch(retrieveLatestCourses(2));
    dispatch(retrieveLatestEvents(2));
    dispatch(retrieveNewsArticlesSearchCategory());
    dispatch(retrieveNewsArticlesSearchAuthor());
  }, [dispatch]);

  const features = {
    featureFocusData: FeatureFocusData,
    ForAuthorsData: ForAuthorsData,
    LatestFeaturesData: LatestFeaturesData,
    RFQuarterData: RFQuarterData,
  };
  const departments = {
    ArticlesFiltereds393Data: ArticlesFiltereds393Data,
    ArticlesFilteredsData397: ArticlesFilteredsData397,
    ArticlesFilteredsData400: ArticlesFilteredsData400,
    ArticlesFilteredsData404: ArticlesFilteredsData404,
  };

  // On Change Start Date
  const handleStartDate = (date: Date) => {
    if (date) {
      let curFromDate = new Date(date);
      let getFromDate = curFromDate.toLocaleDateString();
      setFromDate(getFromDate);

      setUrlFromDate(formatDate(date));
    }
  };

  // On Change End Date
  const handleEndDate = (date: Date) => {
    if (date) {
      let curToDate = new Date(date);
      let getToDate = curToDate.toLocaleDateString();
      setToDate(getToDate);

      setUrlToDate(formatDate(date));
    }
  };

  // On change Author
  const handleAuthor = (value: string) => {
    setAuthorCode(value);
  };

  // Remove the Keyword filter
  const handleCategory = (value: number) => {
    setCategoryID(value);
  };

  //  Update URL
  const updateUrl = (urlKeyword: string, urlCategoryID: number, urlAuthorCode: string, urlFromDate: string, urlToDate: string) => {
    const urlSearchParams = new URLSearchParams();
    urlKeyword && urlSearchParams.append("searchtext", urlKeyword.toString());
    urlCategoryID && urlSearchParams.append("category", urlCategoryID.toString());
    urlAuthorCode && urlSearchParams.append("author", urlAuthorCode);
    urlFromDate && urlSearchParams.append("fromdate", urlFromDate);
    urlToDate && urlSearchParams.append("todate", urlToDate);
    navigator(`/news-and-articles/news-articles?${urlSearchParams.toString()}`);
  };

  //  Handle search
  const handleSearch = () => {
    updateUrl(keyword, categoryID, authorCode, urlFromDate, urlToDate);
  };

  // Handle Start today date
  const handleStartTodayDate = () => {
    setStartDate(new Date());
  };

  // Handle End today date
  const handleEndTodayDate = () => {
    setEndDate(new Date());
  };

  return (
    <>
      <Helmet>
        <title>{ArticlesFilteredsData[0]?.menuItemName}</title>
      </Helmet>
      <NewsAndArticlesStyles />
      <div className="container">
        <div className="text-center top-banner" id="topbanner">
          <div className="CMSBanner Banner topbanner gadsbanner" id="div-gpt-ad-1611326459208-0" style={{ width: "970px", height: "90px", margin: '0 auto', display: "none" }}>
          </div>
          <div className="CMSBanner Banner topmobile gadsbanner" id="div-gpt-ad-1611693088874-0" style={{ width: "300px", height: "50px", margin: '0 auto', display: "none" }}>
          </div>
        </div>
      </div>
      <style type="text/css">{`
        @media only screen and (max-width: 1260px) {
          .topmobile, .contentmobile {
            display: block;
          }
          .topbanner, .contentbanner {
            display: none;
          }
        }
        @media only screen and (min-width: 1260px) {
          .topmobile, .contentmobile {
            display: none;
          }
          .topbanner, .contentbanner {
            display: block;
          }
        }
        #topbanner { display: block !important; }
      `}</style>
      {/* Filter */}
      <div className="container">
        <div className="filter filter-news-search fitler-event-search">
          <div className="search-block">
            <div className="container">
              <div className="row">
                <div className="col-sm-12">
                  <div className="search-content">
                    <input
                      name="keyword"
                      type="text"
                      id="p_lt_ctl04_SiteMainPlaceholder_p_lt_ctl00_NewsSmartQuickSearchFilter_txtSearchtext"
                      className="form-control mainfield"
                      placeholder="Search"
                      onChange={(e) => {
                        setKeyword(e.target.value);
                      }}
                      onClick={() => setFormOpen(true)}
                    />
                    <div className="btn-content">
                      <div>
                        <button
                          className={`btn btn-default btn-responsive filter-btn filter-toggle ${formOpen ? "active" : ""}`}
                          data-toggle
                          data-hold="true"
                          data-target="toggledContent_EventFilter"
                          onClick={() => setFormOpen(!formOpen)}
                        >
                          Filters
                        </button>
                      </div>
                      <div id="pnlButtons">
                        <input
                          type="submit"
                          name="p$lt$ctl04$SiteMainPlaceholder$p$lt$ctl00$NewsSmartQuickSearchFilter$fltButtons$btnSearch"
                          value="Search"
                          id="btnSearch"
                          className="btn btn-default"
                          onClick={() => handleSearch()}
                        />
                      </div>
                    </div>
                  </div>
                  <Collapse in={formOpen}>
                    <div className="form-container" id="toggledContent_EventFilter">
                      <div className="row">
                        <div className="form-group col-md-2 hide">
                          <label
                            htmlFor="p_lt_ctl04_SiteMainPlaceholder_p_lt_ctl00_NewsSmartQuickSearchFilter_txtSearchtext"
                            id="p_lt_ctl04_SiteMainPlaceholder_p_lt_ctl00_NewsSmartQuickSearchFilter_lblNewTitle"
                            className="EditingFormLabel"
                          >
                            Keyword
                          </label>
                        </div>
                        <div className="form-group col-md-3">
                          <label
                            htmlFor="p_lt_ctl04_SiteMainPlaceholder_p_lt_ctl00_NewsSmartQuickSearchFilter_dtFromDate"
                            id="p_lt_ctl04_SiteMainPlaceholder_p_lt_ctl00_NewsSmartQuickSearchFilter_lblFromDate"
                            className="EditingFormLabel"
                          >
                            From Date
                          </label>
                          {/* <DateRangePicker
                                                        editable={true}
                                                        format="MM-dd-yyyy"
                                                        //   value={[new Date(fromDate), new Date(toDate)]}
                                                        placeholder="Select Date Range"
                                                        defaultCalendarValue={[addMonths(today, -1), today]}
                                                        disabledDate={(date) => isAfter(date, new Date())}
                                                        onChange={(e) => {
                                                            handleRangeDate(e);
                                                        }}
                                                    /> */}
                          <DatePicker
                            selected={startDate}
                            onChange={(date: React.SetStateAction<Date | null>) => {
                              date && setStartDate(date);
                              handleStartDate(date as Date);
                            }}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            className="calander-height"
                            placeholderText="Select Date"
                            dropdownMode="select"
                            selectsStart
                            startDate={startDate}
                            endDate={endDate}
                            todayButton="Today"
                          >
                            {/* <div className="calander-btns">
                            <input type="submit" className="btn btn-default btn-block" value="TODAY" onClick={handleStartTodayDate} />
                            <input type="submit" className="btn btn-secondary btn-block btn-primary" value="SELECT" />
                          </div> */}
                          </DatePicker>
                        </div>
                        <div className="form-group col-md-3">
                          <label
                            htmlFor="p_lt_ctl04_SiteMainPlaceholder_p_lt_ctl03_NewsSmartSearchFilter_dtToDate"
                            id="p_lt_ctl04_SiteMainPlaceholder_p_lt_ctl03_NewsSmartSearchFilter_lblToDate"
                            className="EditingFormLabel"
                          >
                            To Date
                          </label>

                          <DatePicker
                            selected={endDate}
                            onChange={(date: React.SetStateAction<Date | null>) => {
                              date && setEndDate(date);
                              handleEndDate(date as Date);
                            }}
                            className="calander-height"
                            selectsEnd
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            placeholderText="Select Date"
                            dropdownMode="select"
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                            todayButton="Today"
                          >
                            {/* <div className="calander-btns">
                            <input type="submit" className="btn btn-default btn-block" value="TODAY" onClick={handleEndTodayDate} />
                            <input type="submit" className="btn btn-secondary btn-block btn-primary" value="SELECT" />
                          </div> */}
                          </DatePicker>
                        </div>

                        <div className="form-group col-md-3">
                          <label htmlFor="p_lt_ctl04_SiteMainPlaceholder_p_lt_ctl00_NewsSmartQuickSearchFilter_drpCategories" className="EditingFormLabel">
                            Category
                          </label>
                          <select name="categories" id="categories" className="form-control" value={categoryID} onChange={(e) => handleCategory(Number(e.target.value))}>
                            <option value="0">Select Categories</option>
                            {NewsArticlesSearchCategoryData &&
                              NewsArticlesSearchCategoryData[0]?.categoryInfos?.map((item, index) => {
                                return (
                                  <option key={index} value={item.categoryId}>
                                    {item.categoryName}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                        <div className="form-group col-md-3" style={{ display: "none" }}>
                          <label htmlFor="p_lt_ctl04_SiteMainPlaceholder_p_lt_ctl00_NewsSmartQuickSearchFilter_drpTopic" className="EditingFormLabel">
                            Topic
                          </label>
                          <select
                            name="p$lt$ctl04$SiteMainPlaceholder$p$lt$ctl00$NewsSmartQuickSearchFilter$drpTopic"
                            id="p_lt_ctl04_SiteMainPlaceholder_p_lt_ctl00_NewsSmartQuickSearchFilter_drpTopic"
                            className="form-control"
                          >
                            <option value="0">Select Topic</option>
                            <option value="Biotech">Biotech</option>
                            <option value="Brexit">Brexit</option>
                            <option value="Careers">Careers</option>
                            <option value="Combination Products">Combination Products</option>
                            <option value="EU MDR">EU MDR</option>
                            <option value="IVDs">IVDs</option>
                            <option value="Management">Management</option>
                            <option value="Medical Devices">Medical Devices</option>
                            <option value="Pharmaceuticals">Pharmaceuticals</option>
                            <option value="Regulatory Intelligence">Regulatory Intelligence</option>
                          </select>
                        </div>
                        <div className="form-group col-md-3">
                          <label htmlFor="p_lt_ctl04_SiteMainPlaceholder_p_lt_ctl00_NewsSmartQuickSearchFilter_drpAuthors" className="EditingFormLabel">
                            Author
                          </label>
                          <select name="author" id="author" className="form-control" value={authorCode} onChange={(e) => handleAuthor(e.target.value)}>
                            <option value="0">Select Author</option>
                            {NewsArticlesSearchAuthorData &&
                              NewsArticlesSearchAuthorData[0]?.authors?.map((item, index) => {
                                return (
                                  <option key={index} value={item.authorsCode}>
                                    {item.authorName}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Tabs */}
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-12 logo-block">
              <Link to="#features" className="btn btn-default btn-responsive" target="_parent">
                RF Features
              </Link>
              <Link to="/news-and-articles/rf-quarterly" className="btn btn-default btn-responsive">
                RF Quarterly
              </Link>
              <Link to="/news-and-articles/news-articles" className="btn btn-default btn-responsive">
                All Articles
              </Link>
              <Link to="/preferences?type=news" className="btn btn-default btn-responsive">
                Subscribe
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="main-column news-landing news-article-landing">
        <div className="container">
          <div className="row main_row">
            <div className="col-md-12">
              <div className="article-block">
                <div className="featured-post">
                  <div className="row">
                    {ArticlesFilteredsPinnedData[0]?.articlesList?.map((item, index) => {
                      return (
                        <React.Fragment key={index}>
                          <div className="col-sm-12 col-md-12 col-lg-4 col-xl-3 align-self-start">
                            <div className="featured-image">
                              <Link to={item.articleUrl.toLowerCase()} title={item.articleName}>
                                <img src={item?.articleTeaserImage} alt={item.articleTeaserText} className="img-pin-article-off" />
                              </Link>
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-12 col-lg-8 col-xl-9">
                            <div className="featured-content">
                              <div className="post-meta">
                                <div className="data-right">
                                  <span className="article-date">{item.articleReleaseDate}</span> | <span className="authors"> By <span className="auth-name" dangerouslySetInnerHTML={{ __html: item.author }}></span>
                                  </span>
                                </div>
                                <div className="category-tag">
                                  <span className="category" dangerouslySetInnerHTML={{ __html: item.badgeUrl }}></span>
                                </div>
                              </div>
                              <Link to={item.articleUrl.toLowerCase()}>
                                <h3> {item.articleName} </h3>
                              </Link>
                              <p>{item.articleTeaserText}</p>
                              <Link className="link-see-more" to={item.articleUrl.toLowerCase()}>
                                See More
                              </Link>
                            </div>
                          </div>
                        </React.Fragment>
                      );
                    })}
                  </div>
                </div>
              </div>

              {/* show sponsored Article if published */}
              {ArticlesFiltereds399Data[0]?.articlesList?.length === 1 && ArticlesFiltereds399Data[0]?.articlesList?.map((item, index: number) => {
                return (
                  <React.Fragment key={index}>
                    <div className="sponsored-content" style={{ borderBottom: "1px solid #B3B3B3" }} >
                      <div className="sponsoredborder" style={{ padding: "20px 25px !important" }}>
                        <div className="row">
                          <div className="col-sm-12 col-md-2 align-self-start">
                            <div className="featured-image">
                              <Link to={item.articleUrl.toLowerCase()} >
                                <img src={item?.articleTeaserImage} alt={item.articleName} loading="lazy" />
                              </Link>
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-10">
                            <div className="summary-latest">
                              <div className="post-meta">
                                <div className="data-right">
                                  <span className="article-date">{item.articleReleaseDate}</span> | <span className="authors"> By <span dangerouslySetInnerHTML={{ __html: item.author }}></span></span>
                                </div>
                                <div className="category-tag">
                                  <span className="category" dangerouslySetInnerHTML={{ __html: item.badgeUrl }}></span>
                                </div>
                              </div>
                              <Link to={item.articleUrl.toLowerCase()}><h3>{item.articleName}</h3></Link>
                              <p>{item.articleTeaserText}</p>
                              <Link className="link-see-more" to={item.articleUrl.toLowerCase()}>See More</Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                );
              })}
              {ArticlesFiltereds399Data[0]?.articlesList?.length === 2 && (
                <div className="sponsoredborder row" style={{ borderBottom: "1px solid #B3B3B3", padding: "20px 25px !important", marginTop: "15px" }}>
                  {ArticlesFiltereds399Data[0]?.articlesList?.map((item, index: number) => {
                    return (
                      <React.Fragment key={index}>
                        <div className="sponsored-content col-md-6" style={index === 0 ? { borderRight: "1px solid #B3B3B3" } : {} } >
                          <div className="row">
                            <div className="col-lg-5 col-md-12 align-self-start">
                              <div className="featured-image">
                                <Link to={item.articleUrl.toLowerCase()} >
                                  <img src={item?.articleTeaserImage} alt={item.articleName} loading="lazy" />
                                </Link>
                              </div>
                            </div>
                            <div className="col-sm-12 col-md">
                              <div className="summary-latest">
                                <div className="post-meta">
                                  <div className="data-right">
                                    <span className="article-date">{item.articleReleaseDate}</span> | <span className='authors'>By <span dangerouslySetInnerHTML={{ __html: item.author }}></span></span>
                                  </div>
                                  <div className="category-tag">
                                    <span className="category" dangerouslySetInnerHTML={{ __html: item.badgeUrl }}></span>
                                  </div>
                                </div>
                                <Link to={item.articleUrl.toLowerCase()}><h3>{item.articleName}</h3></Link>
                                <p>{item.articleTeaserText}</p>
                                <Link className="link-see-more" to={item.articleUrl.toLowerCase()}>See More</Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    );
                  })}
                </div>
              )}

              {/* second Article sec */}
              <NewsArticleTop articles={ArticlesFilteredsData} />

              <div className="row img-width">
                <div className="col-md-12 text-center">
                  <div className="CMSBanner Banner contentbanner gadsbanner" id="div-gpt-ad-1649701637206-0" style={{ minWidth: "970px", minHeight: "90px", display: "none" }}></div>
                  <div className="CMSBanner Banner contentmobile gadsbanner" id="div-gpt-ad-1649701809430-0" style={{ minWidth: "300px", minHeight: "50px", display: "none" }}></div>
                </div>
              </div>

              {/* Features slider  */}
              <NewsArticleSlider
                features={features}
                cardMainTitle="features-section"
                cardMainHeading="Features"
                cardSlidersec="feature-slider"
                cardSecTitle="feature-single"
                cardSecSubTitle="feature-title"
                cardSecContent="feature-content"
                cardSecInfo="feature-info"
              />

              {/* Add Banner */}
              <div className="row img-width">
                <div className="col-md-12 text-center">
                  <div className="CMSBanner Banner contentbanner gadsbanner" id="div-gpt-ad-1649701921828-0" style={{ minWidth: "970px", minHeight: "90px", display: "none" }}></div>
                  <div className="CMSBanner Banner contentmobile gadsbanner" id="div-gpt-ad-1649701861184-0" style={{ minWidth: "300px", minHeight: "50px", display: "none" }}></div>
                </div>
              </div>

              {/* Departments */}
              <DepartmentsSlider
                departments={departments}
                cardMainTitle="category-sections"
                cardMainHeading="Departments"
                cardSlidersec="categories gray-dots"
                cardSecTitle="single-category"
                cardSecSubTitle="category-title"
                cardSecContent="category-content"
                cardSecInfo="category-info"
              />

              {/* News Article Bottom */}
              <NewsArticleBottom articles={ArticlesFilteredsData} />

              <div className="col-sm-12 d-flex justify-content-center">
                <Link className="btn btn-default btn-responsive mt-3" to={`/news-and-articles/news-articles?page=2`}>
                  See More News
                </Link>
              </div>
              <a id="rssLink" className="FeedLink" href="/news-and-articles/rss.xml">
                <img
                  id="rssFeedImg" className="FeedIcon" src="https://rapsprod.blob.core.windows.net/rapsk13/raps/media/news-images/rss-icon.png"
                  alt="Regulatory Focus Articles"
                />
              </a>
              <a id="rssLinkText" className="FeedLink" href="/news-and-articles/rss.xml">
                <span id="rssFeedName" className="FeedCaption">
                  {" "}
                  RSS Feed 2.0
                </span>
              </a>

              {/* Discover more sec */}
              <Discover />

              <div className="col-md-12">
                <div className="col-md-12">
                  <div className="discover-more">
                    <div className="container">
                      <div className="row discover">
                        {/* <div className="col-sm-12 d-flex justify-content-center">
                                                    <h2>Discover more of what matters to you</h2>
                                                </div> */}
                        <div className="col-md-12">
                          <div className="row">
                            <div className="row discover-slider owl-carousel owl-theme features-section lg-hide">
                              <Slider {...settings}>
                                <NewsCardArticle article={trendingNewsData} />
                                <BooksCardArticle article={featuredBooksData} />
                                <EventsCardArticle article={popularEventsData} />
                                <CoursesCardArticle article={featuredLearningData} />
                              </Slider>
                            </div>
                            <div className="row discover-slider owl-carousel owl-theme lg-show">
                              <NewsCardArticle article={trendingNewsData} />
                              <BooksCardArticle article={featuredBooksData} />
                              <EventsCardArticle article={popularEventsData} />
                              <CoursesCardArticle article={featuredLearningData} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default NewsAndArticlesComponent;
